import { useEffect } from 'react'
import { FaCheck, FaXmark } from "react-icons/fa6"
import { useAuth } from '../../Providers/AuthProvider'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

const WholeSalePricesSwitch = ({ isMobileView }) => {
    const { authState, setWholesalePrices, wholesalePrices } = useAuth()
    const location = useLocation()
    const isCartPage =
        location.pathname.toLowerCase() === "/cart" ||
        location.pathname.toLocaleLowerCase().includes("/offerrequest")

    useEffect(() => {
        if (isCartPage && !wholesalePrices) {
            setWholesalePrices(true)
        }
    }, [isCartPage])

    const handleWholesaleChange = () => {
        if (isCartPage) {
            toast.warning('Nie możesz tego zmienić w tym miejscu')
            return
        }
        setWholesalePrices(prev => !prev)
    }

    const isCollapse = authState.user && authState.custId ? '' : ' hidden'
    const fontWeight = isMobileView ? 'normal' : 'bold'
    const positionStyle = isMobileView ? '' : 'justify-content-center'

    return (
        <div className={`col d-flex  ${isCollapse}`}>
            <span className={`me-4 ${positionStyle}`} style={{ fontWeight: fontWeight }}>Ceny hurtowe</span>
            <div className='d-flex justify-content-end'></div>
            <div className={`navbar-custom-switch ${wholesalePrices ? "active" : ""}`} onClick={handleWholesaleChange}>
                <div className="navbar-custom-switch-circle">
                    {wholesalePrices ? <FaCheck color='white' /> : <FaXmark color='black' />}
                </div>
            </div>
        </div>
    )
}

export default WholeSalePricesSwitch